if(window.location.search != '') {
	var locationQueryParams = window.location.search;
}

customElements.define('collection-filters-form', class CollectionFiltersForm extends HTMLElement {
	constructor() {
		super();

		this.querySelector('form').addEventListener('input', this.onSubmitHandler.bind(this));
	}

	onSubmitHandler(event) {
		event.preventDefault();

		var allInputs = document.querySelectorAll('input');
		allInputs.forEach(input => {
			if(input != event.target && input.id == event.target.id) {
				if(event.target.checked == true) {
					input.checked = true;
				} else {
					input.checked = false;
				}
			}
		});

		const formData = new FormData(event.target.closest('form'));
		const searchParams = new URLSearchParams(formData).toString();
		this.renderPage(searchParams, event);
	}

	renderPage(searchParams, event, updateURLHash = true) {
		const sections = CollectionFiltersForm.getSections();

		sections.forEach((section) => {
			if(window.location.search != '') {
				searchParams = locationQueryParams + '&' + searchParams;
				searchParams = searchParams.replace('?','')
			}
			const sectionUrl = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const newUrl = `${window.location.pathname}?${searchParams}`;
			// console.log(sectionUrl)
			// console.log(newUrl);
			this.renderSectionFromFetch(sectionUrl, newUrl, event);
			// filterCountCheck();
		})
	}

	renderSectionFromFetch(sectionUrl, newUrl, event) {
		fetch(sectionUrl)
			.then(response => response.text())
			.then((responseText) => {
				const newHTML = new DOMParser().parseFromString(responseText, 'text/html').getElementById('CollectionProductGrid').innerHTML;				
				document.getElementById('CollectionProductGrid').innerHTML = newHTML;
				window.history.replaceState({ }, '', newUrl);
			})
			.then(() => {
				theme.reinitProductGridItem();
			});
	}

	static getSections() {
		return [
			{
				section: document.getElementById('CollectionProductGrid').dataset.id,
			}
		]
	}
});

/* Filter Modal Controller */
const filterModal = document.querySelector('.filter-sort-modal--mobile'),
	filterBtnClose = document.querySelector('.filter__modal-close'),
	filterBtnOpen = document.querySelector('.filter__modal-open'),
	body = document.querySelector('body');

	filterBtnOpen.addEventListener('click', function(e) {
		e.preventDefault();
		filterModal.classList.add('is-open');
		body.style.overflow = 'hidden';
	});
	
	filterBtnClose.addEventListener('click', function() {
		filterModal.classList.remove('is-open');
		body.style.overflow = 'unset';
	});
	
	document.addEventListener("keydown", function(event) {
		if(event.keyCode === 27){
		filterModal.classList.remove('is-open');
		body.style.overflow = 'unset';
		}
	});

/* Clear Filters Button Controller */
function filterCountCheck()  {
	const clearFiltersBtns = document.querySelectorAll('.active-filters');
	if(document.querySelector('.collection-grid__outer').dataset.filtercount > 0) {
		clearFiltersBtns.forEach(btn => {
			btn.classList.remove('is-visible');
		});
	} else {
		clearFiltersBtns.forEach(btn => {
			btn.classList.remove('is-visible');
		});
	}
}

/* Trigger Class = "accordion" */
/* Content must be next direct sibling, with the class "accordion__content" */
var accordion = document.getElementsByClassName("accordion");

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", function() {
    accordionToggle(this);
  });
}

function accordionToggle(trigger) {
  var content = trigger.nextElementSibling;

  trigger.classList.toggle("open");
  content.classList.toggle("open");

  if (content.style.maxHeight){
    content.style.maxHeight = content.scrollHeight + "px";
    trigger.dataset.accordionicon = "+"
    setTimeout(() => {
    content.style.maxHeight = null;
    }, 1);
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    trigger.dataset.accordionicon = "-"
    setTimeout(() => {
      content.style.maxHeight = "none";
    }, 200);
  } 
}